export default "__VITE_ASSET__DeaNz8vQ__"